<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="my-2 grey darken-3">
        <v-subheader class="white--text">dark theme</v-subheader>
      </v-col>
      <v-col cols="12" class="my-2 grey lighten-3">
        <v-subheader>light theme</v-subheader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'XImage',
  data() {
    return {}
  }
}
</script>
